import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getClaimTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GeAllClaimTypes}?CompanyCode=${companyCode}&isTrue=${isTrue}`
  );
  return data;
};

const getClaimType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetClaimTypes}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertClaimType = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertClaimType,
    input
  );
  return data;
};

const updateClaimType = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateClaimsTypes,
    input
  );
  return data;
};

export const useGetClaimTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GeAllClaimTypes],
    queryFn: () => getClaimTypes(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetClaimTypeById = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetClaimTypes],
    queryFn: () => getClaimType(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertClaimTypeMutation = () => {
  return useMutation({
    mutationFn: insertClaimType,
  });
};

export const useUpdateClaimTypeMutation = () => {
  return useMutation({
    mutationFn: updateClaimType,
  });
};
